import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BeweLf } from '../../types/bewe-lf';
import {
  EmballageBewe,
  ItemScanBewe,
  ReturnNoteBewe,
  SearchStornoBewe,
  StornoBewe,
  VermerkBewe } from '../../types/return-note';
import { CommonModule, getNumberOfCurrencyDigits } from '@angular/common';
import { SerialNumberViewComponent } from '../serial-number-view/serial-number-view.component';

@Component({
  selector: 'lib-delivery-note-return-card',
  imports: [CommonModule, SerialNumberViewComponent],
  templateUrl: './delivery-note-return-card.component.html',
  styleUrls: ['./delivery-note-return-card.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush })
export class DeliveryNoteReturnCardComponent {
  @Input() bewe!: ReturnNoteBewe;
  @Input() bewelf?: BeweLf;
  @Input() deliveryNoteId?: number | string;

  public isStorno(bewe: ReturnNoteBewe): bewe is StornoBewe {
    return bewe.typ === 'storno';
  }
  public isEmballage(bewe: ReturnNoteBewe): bewe is EmballageBewe {
    return bewe.typ === 'emballage';
  }
  public isVermerk(bewe: ReturnNoteBewe): bewe is VermerkBewe {
    return bewe.typ === 'vermerk';
  }
  public isSearchItem(bewe: ReturnNoteBewe): bewe is SearchStornoBewe {
    return bewe.typ === 'search';
  }
  public isScanItem(bewe: ReturnNoteBewe): bewe is ItemScanBewe {
    return bewe.typ === 'itemScan';
  }

  protected readonly getNumberOfCurrencyDigits = getNumberOfCurrencyDigits;

  patchBewe(id: number | string | undefined, seriennummer: BeweLf['seriennr']): void {
    console.log('test: ', id, seriennummer);
  }
}
